/**
 * Represents an emoji from the Emoji Service that can be used inside TemplateVariables
 */

export var ReadState = /*#__PURE__*/function (ReadState) {
  ReadState["READ"] = "read";
  ReadState["UNREAD"] = "unread";
  return ReadState;
}({});
export var LoadingState = /*#__PURE__*/function (LoadingState) {
  LoadingState["INITIAL"] = "initial";
  LoadingState["LOADING"] = "loading";
  LoadingState["ERROR"] = "error";
  LoadingState["COMPLETE"] = "complete";
  return LoadingState;
}({});
export var TimeGroup = /*#__PURE__*/function (TimeGroup) {
  TimeGroup["TODAY"] = "TODAY";
  TimeGroup["YESTERDAY"] = "YESTERDAY";
  TimeGroup["OLDER"] = "OLDER";
  return TimeGroup;
}({});
export var NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["COMMENT"] = "COMMENT";
  NotificationType["MENTION"] = "MENTION";
  NotificationType["ASSIGN"] = "ASSIGN";
  NotificationType["TRANSITION"] = "TRANSITION";
  NotificationType["TASK"] = "TASK";
  NotificationType["SHARE"] = "SHARE";
  NotificationType["OTHER"] = "OTHER";
  return NotificationType;
}({});
export var RequestReadState = /*#__PURE__*/function (RequestReadState) {
  RequestReadState["UNREAD"] = "unread";
  RequestReadState["ANY"] = "any";
  return RequestReadState;
}({});
export var RequestCategory = /*#__PURE__*/function (RequestCategory) {
  RequestCategory["DIRECT"] = "direct";
  RequestCategory["ANY"] = "any";
  RequestCategory["WATCHING"] = "none";
  return RequestCategory;
}({});
export var ProductFilters = /*#__PURE__*/function (ProductFilters) {
  ProductFilters["ANY"] = "any";
  ProductFilters["JIRA"] = "jira";
  ProductFilters["CONFLUENCE"] = "confluence";
  ProductFilters["BITBUCKET"] = "bitbucket";
  return ProductFilters;
}({});
export var MarkRequestReadState = /*#__PURE__*/function (MarkRequestReadState) {
  MarkRequestReadState["READ"] = "READ";
  MarkRequestReadState["UNREAD"] = "UNREAD";
  return MarkRequestReadState;
}({});